jQuery(function ($) {
  var $root = $(".mp_sel").first();
  if (!$root.length) return;

  var sellingPlanId = $root.data("selling-plan") || "";
  var $pills = $root.find(".mp_sel__qty-pills .mp_sel__qty-pill");
  var $planSub = $root.find('[data-plan="sub"]');
  var $planOtp = $root.find('[data-plan="otp"]');
  var $atcBtn = $(".product-selector_atc");

  function isSubActive() {
    return $planSub.hasClass("mp_sel__plan--featured");
  }

  function formatPerDay(cents, qty) {
    var supplyDays = (parseInt(qty, 10) || 1) * 30;
    return "€" + (parseInt(cents, 10) / 100 / supplyDays).toFixed(2) + "/day";
  }

  function updatePrices($pill) {
    var d = $pill.data();
    var qty = parseInt(d.qty, 10) || 1;

    $planSub.find(".mp_sel__plan-price").text(d.subPrice);
    $planSub.find(".mp_sel__plan-strike").text(d.subCompare);
    $planSub.find(".mp_sel__plan-per-day").text(formatPerDay(d.subCents, qty));

    $planOtp.find(".mp_sel__plan-price").text(d.otpPrice);
    $planOtp.find(".mp_sel__plan-strike").text(d.otpCompare);
    $planOtp.find(".mp_sel__plan-per-day").text(formatPerDay(d.otpCents, qty));
  }

  function getDiscountPercent($pill) {
    var subCents = parseInt($pill.data("sub-cents"), 10) || 0;
    var otpCents = parseInt($pill.data("otp-cents"), 10) || 0;

    if (!subCents || !otpCents || otpCents <= subCents) return 0;

    return Math.round(((otpCents - subCents) / otpCents) * 100);
  }

  function updateBadge($pill) {
    var $badge = $root.find(".mp_sel__qty-badge");
    if (!$badge.length) return;

    var qty = parseInt($pill.data("qty"), 10) || 1;
    var discount;

    if (qty === 1) {
      var $qty2 = $pills.filter(function () {
        return parseInt($(this).data("qty"), 10) === 2;
      });

      discount = $qty2.length ? getDiscountPercent($qty2) : getDiscountPercent($pill);
    } else {
      discount = getDiscountPercent($pill);
    }

    $badge.show().toggleClass("mp_sel__qty-badge--disabled", qty === 1);

    $badge
      .find(".mp_sel__qty-badge-text")
      .text(
        qty === 1
          ? "Buy 2 Save up to " + discount + "%"
          : "Buy " + qty + " Save " + discount + "%"
      );
  }

  function updateDynamicCopy($pill) {
    var qty = parseInt($pill.data("qty"), 10) || 1;
    var discount = getDiscountPercent($pill);
    var supplyDays = qty * 30;

    $planSub.find(".mp_sel__plan-banner").text("Most Popular: Get " + discount + "% Off");
    $planOtp.find(".mp_sel__plan-sub").text(supplyDays + "-Day supply delivered once");
  }

  function updateAtc($pill) {
    if (!$atcBtn.length || !$pill.length) return;

    $atcBtn.data("otp-id", $pill.data("otp-id"));
    $atcBtn.data("sub-id", $pill.data("sub-id"));

    if (isSubActive()) {
      $atcBtn.data("selling-plan", $pill.data("selling-plan") || sellingPlanId);
    } else {
      $atcBtn.removeData("selling-plan");
    }
  }

  function getActivePill() {
    return $root.find(".mp_sel__qty-pills .mp_sel__qty-pill.active").first();
  }

  $pills.on("click", function () {
    var $pill = $(this);

    $pills.removeClass("active");
    $pill.addClass("active");

    updatePrices($pill);
    updateAtc($pill);
    updateBadge($pill);
    updateDynamicCopy($pill);
  });

  $planSub.on("click", function () {
    $planSub.addClass("mp_sel__plan--featured");
    $planOtp.removeClass("mp_sel__plan--featured");
    updateAtc(getActivePill());
  });

  $planOtp.on("click", function () {
    $planOtp.addClass("mp_sel__plan--featured");
    $planSub.removeClass("mp_sel__plan--featured");
    updateAtc(getActivePill());
  });

  $root.find(".mp_sel__cta").on("click", function () {
    var $pill = getActivePill();
    if (!$pill.length) return;

    var data = {
      id: isSubActive() ? $pill.data("sub-id") : $pill.data("otp-id"),
      quantity: 1,
    };

    if (isSubActive()) {
      var planId = $pill.data("selling-plan") || sellingPlanId;
      if (planId) data.selling_plan = planId;
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        $("body").trigger("added.ajaxProduct");
      },
      error: function (err) {
        console.error("ATC error", err);
      },
    });
  });

  var $initPill = getActivePill();
  if ($initPill.length) {
    updatePrices($initPill);
    updateAtc($initPill);
    updateBadge($initPill);
    updateDynamicCopy($initPill);
  }

  $(".mp_gal__thumb").on("click", function () {
    var idx = $(this).data("index");

    $(".mp_gal__thumb").removeClass("active");
    $(this).addClass("active");

    $(".mp_gal__slide").removeClass("active");
    $('.mp_gal__slide[data-index="' + idx + '"]').addClass("active");
  });

  $(document).on("click", ".js-scroll-top", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 500);
  });

  $(document).on("click", ".mp_sel__rating", function (e) {
    e.preventDefault();

    var $target = $(".product_judge-container").first();
    if (!$target.length) return;

    $("html, body").animate(
      {
        scrollTop: $target.offset().top,
      },
      500
    );
  });
});